module.exports = __webpack_public_path__ + "media/contacts/2-77a9b149.png";